export default __webpack_public_path__ + "f5dc1855175796dd2d2698d1e5ae8764.png";